import { formatValueDateToMoment } from './formatValueDateToMoment';
import { values } from '@morf/proto/values/v1/values_ts_proto';

export const formatValueDateToMonth = (valueDate: values.v1.Date): string =>
  formatValueDateToMoment(valueDate).format('MMMM'); // 'MMMM' for the full month name (e.g., January)
